export default {
  addOns: "Extra's",
  availabilityDaySelector: 'Beschikbaarheidsdatumselector',
  unavailable: 'Niet beschikbaar',
  person: 'persoon',
  people: 'personen',
  reserveNow: 'Nu reserveren',
  selectTime: 'Selecteer tijd',
  select: 'Selecteer',
  reserve: 'Reserveren',
  time: 'Tijd',
  tier: 'Niveau',
  questions: 'Vragen',
  addToCart: 'Toevoegen aan winkelwagen',
  checkout: 'Afrekenen',
  total: 'Totaal',
  availability: 'Beschikbaarheid',
  whatsIncluded: 'Wat is inbegrepen',
  showMore: 'Meer tonen',
  showLess: 'Minder tonen',
  session: 'Sessie',
  viewDetails: 'Details bekijken',
  findAvailability: 'Beschikbaarheid zoeken',
  loading: 'Laden',
  capacity: 'Capaciteit',
  noAvailableSessionsOnThisDate: 'Geen beschikbare sessies op deze datum',
  noGroupAvailableOnThisDateAndTime:
    'Geen {{groupTitle}} beschikbaar op deze datum en tijd',
  noCollectionFound: 'Geen collectie gevonden!',
  noResourceGroupFound: 'Geen resourcegroep gevonden!',
  noData: 'Geen gegevens!',
  continue: 'Doorgaan',
  night: 'nacht',
  nights: 'nachten',
  noAvailableSessionsForSelectedDates:
    'Sommige datums in uw selectie hebben geen beschikbare sessies. Selecteer andere datums.',
  from: 'vanaf',
  dateRangeSelector: 'Datumbereikselector',
  startTime: 'Starttijd',
  duration: 'Duur',
  lengthOfStay: 'Verblijfsduur',
  startDate: 'Startdatum',
  endDate: 'Einddatum',
  selectDates: 'Selecteer datums',
  more: 'Meer',
  selectStartTime: 'Kies een starttijd',
  endTime: 'Eindtijd',
  selectEndTime: 'Kies een eindtijd',
  morning: 'Ochtend',
  afternoon: 'Middag',
  save: 'Opslaan',
  selectDuration: 'Kies een duur',
  forLength: 'voor {{length}}',
  moreDates: '{{count}} meer',
  addDate: 'Datum toevoegen',
  start: 'Start',
  end: 'Einde',
  pickupFrom: 'Ophalen vanaf',
  returnBy: 'Terugbrengen vóór',
  day: 'dag',
  days: 'dagen',
  hour: 'uur',
  hours: 'uur',
};
